export default __webpack_public_path__ + "static/media/misc-makeupA-1440w.e72173b4.png";